import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { TableCell, TableContainer } from '@mui/material';

const StyledTable = styled(TableContainer)`
  max-height: ${(props) => props.height || 'auto'};
  min-height: ${(props) => props.height || 'auto'};
  max-width: 100%;
  background: ${COLOR.white};
  border-radius: 16px 16px 0 0;

  .header-cell {
    background-color: ${(props) =>
      props.stickyHeader ? '#f6f6f8' : COLOR.backgroundDefault};
    color: ${COLOR.dark};
    padding: ${(props) => (props.headerPadding ? props.headerPadding : '16px')};
    z-index: 10;
    height: ${(props) => (props.cellHeight ? props.cellHeight : '56px')};
    box-sizing: border-box;
  }

  .header-item {
    display: flex;
    align-items: center;
    & .MuiIconButton-root {
      padding-right: 0px;
      padding-left: 0px;
      margin-left: 8px;
      margin-right: -8px;
    }
  }

  .header-left {
    justify-content: left;
  }

  .header-right {
    justify-content: right;
  }

  .header-center {
    justify-content: center;
  }

  .header-title {
    color: ${COLOR.darkGray};
  }

  .header-icon {
    color: ${COLOR.darkBlue} !important;
  }

  .body-row {
    &:hover {
      background: ${TRANSPARENT_COLOR.bgrGray};
      position: relative;

      .hover-visible {
        display: flex;
        position: absolute;
        right: 0px;
        z-index: 1;
        border: 0;
        background: linear-gradient(
            ${TRANSPARENT_COLOR.bgrGray},
            ${TRANSPARENT_COLOR.bgrGray}
          ),
          linear-gradient(white, white);
      }
    }

    .hover-visible {
      display: none;
    }
    cursor: ${(props) => (props.isRowClickable ? 'pointer' : 'default')};
  }
`;

const StyledTableCell = styled(TableCell)`
  .header-cell {
    background-color: ${COLOR.indigo[4]};
    color: ${COLOR.dark};
    padding: 6px 12px;
    width: ${(props) => (props.width ? props.width : 'auto')};
  }

  &.body-cell {
    border-bottom: 1px solid ${COLOR.divider};
    padding: 16px;
    width: ${(props) => (props.cellWidth ? props.cellWidth : 'auto')};
    height: ${(props) => (props.bodyStyle ? props.bodyStyle.height : '56px')};
    box-sizing: border-box;
  }

  .hidden {
    display: none !important;
  }
`;

export { StyledTable, StyledTableCell };
